import { formatUIDate } from 'utils/helpers'
// Align type is not exported from the module, so define it locally
type Align = 'center' | 'justify' | 'left' | 'right'

export const columns = [
  { field: 'globalId', title: 'Marca', align: 'left' as Align, width: '100px' },
  {
    field: 'adAccount',
    title: 'AD',
    align: 'left' as Align,
    disableSorting: true,
    width: '80px',
    render: row => (row.adAccount ? 'Yes' : 'No')
  },
  {
    field: 'ldapAccount',
    title: 'LDAP',
    align: 'left' as Align,
    disableSorting: true,
    width: '80px',
    render: row => (row.ldapAccount ? 'Yes' : 'No')
  },
  {
    field: 'googleAccount',
    title: 'Google',
    align: 'left' as Align,
    disableSorting: true,
    width: '80px',
    render: row => (row.googleAccount ? 'Yes' : 'No')
  },
  {
    field: 'startDate',
    title: 'Valid',
    align: 'left',
    type: 'date',
    width: '150px',
    disableSorting: true,
    collapsible: true,
    render: row => (
      <div>
        <div>START: {row.startDate}</div>
        <div>END: {row.endDate}</div>
      </div>
    )
  },
  { field: 'jobTitle', title: 'Position', align: 'left' as Align },
  {
    field: 'email',
    title: 'Email',
    align: 'left' as Align,
    render: row => (row.email && row.email !== 'null' ? row.email : '')
  },
  {
    field: 'manager',
    title: 'Manager',
    align: 'left' as Align,
    disableSorting: true,
    render: row => (row.manager ? `${row.manager.firstName} ${row.manager.lastName}` : '')
  },
  {
    field: 'externalPartnerType.name',
    title: 'Type',
    align: 'left' as Align,
    width: '100px',
    render: row => row.externalPartnerType.name
  },
  {
    field: 'status',
    title: 'Status',
    align: 'left' as Align,
    width: '100px',
    render: row => row.status.name
  }
]

export const getNormalizedInitialManager = (manager: unknown): number | null => {
  if (!manager) return null
  if (typeof manager === 'number') return manager
  if (typeof manager === 'object' && 'id' in manager) {
    const id = (manager as any).id
    const num = typeof id === 'string' ? parseInt(id, 10) : id
    return Number.isNaN(num) ? null : num
  }
  return null
}
